function initVDivideStory(container = document) {
  const section =
    container.querySelector('#vdivide-story') ||
    document.querySelector('#vdivide-story');

  if (!section) return;

  const scrollArea = section.querySelector('.story-scroll');
  const panels = Array.from(section.querySelectorAll('[data-story-panel]'));
  const nav = section.querySelector('#story-nav');
  const progressCircle = section.querySelector('#story-progress-circle');
  const progressCurrent = section.querySelector('#story-progress-current');

  if (!scrollArea || !panels.length || !nav) return;

  const groups = [];

  panels.forEach((panel) => {
    const group = panel.dataset.storyGroup || 'Story';

    if (!groups.includes(group)) {
      groups.push(group);
    }
  });

  nav.innerHTML = '';

  groups.forEach((group, index) => {
    const button = document.createElement('button');

    button.type = 'button';
    button.className = `story-nav-item${index === 0 ? ' is-active' : ''}`;
    button.textContent = group;
    button.dataset.storyGroup = group;

    button.addEventListener('click', () => {
      const target = panels.find((panel) => {
        return panel.dataset.storyGroup === group;
      });

      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    nav.appendChild(button);
  });

  const navItems = Array.from(nav.querySelectorAll('.story-nav-item'));

  if (progressCircle && !progressCircle.dataset.clickBound) {
    progressCircle.addEventListener('pointerup', () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const activePanel = panels.find((panel) =>
        panel.classList.contains('is-active')
      );

      const activeGroup = activePanel?.dataset?.storyGroup || groups[0];
      const currentGroupIndex = groups.indexOf(activeGroup);
      const nextGroup = groups[(currentGroupIndex + 1) % groups.length];

      const target = panels.find((panel) => {
        return panel.dataset.storyGroup === nextGroup;
      });

      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    progressCircle.dataset.clickBound = 'true';
  }

  function setActive(panel) {
    const activeGroup = panel.dataset.storyGroup || 'Story';
    const activeIndex = panels.indexOf(panel);

    panels.forEach((item) => {
      item.classList.toggle('is-active', item === panel);
    });

    navItems.forEach((btn) => {
      btn.classList.toggle(
        'is-active',
        btn.dataset.storyGroup === activeGroup
      );
    });

    if (progressCurrent) {
      const label = window.matchMedia('(max-width: 749px)').matches
        ? `${activeGroup} • ${String(activeIndex + 1).padStart(2, '0')}`
        : String(activeIndex + 1).padStart(2, '0');

      progressCurrent.textContent = label;
    }
  }

  function updateProgress() {
    const maxScroll = scrollArea.scrollHeight - scrollArea.clientHeight;

    if (maxScroll <= 0) return;

    const progress = (scrollArea.scrollTop / maxScroll) * 100;

    if (progressCircle) {
      progressCircle.style.setProperty('--story-progress', progress);
    }
  }

  scrollArea.addEventListener('scroll', updateProgress, { passive: true });

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

      if (visible) {
        setActive(visible.target);
      }
    },
    {
      root: scrollArea,
      threshold: [0.35, 0.5, 0.65, 0.8]
    }
  );

  panels.forEach((panel) => observer.observe(panel));

  setActive(panels[0]);
  updateProgress();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      section.classList.add('is-ready');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initVDivideStory(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initVDivideStory(event.target);
});
